// extracted by mini-css-extract-plugin
export default {"asterism":"koranskolene-v0-asterism-E8DdZ"};